// Module
var code = `
    <button class="examples-nav-button examples-nav-button-back" id="prev-example" data-dir-num="-1"  data-dir="back" aria-label="Previous Example">
      <!--  <svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>-->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1E124A"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>

    </button>
    <button class="examples-nav-button examples-nav-button-forward" data-dir-num="1" data-dir="forward" id="next-example" aria-label="Next Example">
      <!--  <svg viewBox="0 0 24 24"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>-->

        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1E124A"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>

    </button>
`;
// Exports
module.exports = code;